import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '体验增强功能',
    type: 'SF_4',
}
